
import * as forgerock from '@forgerock/javascript-sdk';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode'
import { getLocationParamer } from '@/utils/common'
import { forgerockSet } from '@/utils/arkleConfig'
import Cookies from "js-cookie";
import { useArkleNextHook } from './useArkleNextHook';
import {
    getPersonalInfo
} from '@/api/profile'
import { useTranslation } from "react-i18next";

export const useLoginLogout_FR = () => {
    const [, setCurrentStep] = useState();
    const [loginIncorrectMsg,  setLoginIncorrectMsg] = useState('')
    const [isMissingMobile, setIsMissingMobile] = useState(false);
    const [jwtToken, setJwtToken] = useState('');
    const { next } = useArkleNextHook()
    const { t, i18n } = useTranslation();
    useEffect(() => {
        forgerockSet()
    }, [])
    const clearSession = () => {
        sessionStorage.removeItem('isBet')
        sessionStorage.removeItem('jwtToken')
        sessionStorage.removeItem('webId')
        sessionStorage.removeItem('betAcct')
        document.cookie = "access_token=" + "" + "; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + window.location.hostname.split('.').slice(-2).join('.') + ";path=/";
    }
    const refreshToken = async (token) => {
        //authorize token
        const tokens = await forgerock.TokenManager.getTokens({
            forceRenew: true,
            login: 'embedded',
            csrf: token,
            decision: 'allow',
            logger: (l) => console.log('get token', l),
        });


        const accessTokens = tokens.accessToken;
        const idTokens = tokens.idToken;
        setJwtToken(accessTokens);

        return {accessTokens, idTokens};
    }
    const FR_LoginSuccess = async (step) => {
        //remove as login stage completed
        window.sessionStorage.removeItem("ArkleStage");

        const token = step.getSessionToken();     
        const {accessTokens, idTokens} = await refreshToken(token);
        
    //    const accessTokens = token

        const jwtDecodeStr = jwtDecode(accessTokens)
        console.log(jwtDecodeStr, 'jwtDecodeStr')
        sessionStorage.setItem('jwtToken', accessTokens)
        if(jwtDecodeStr.webId)
            sessionStorage.setItem('webId', jwtDecodeStr.webId)
        if(jwtDecodeStr.betAcct)
            sessionStorage.setItem('betAcct', jwtDecodeStr.betAcct)

        if(jwtDecodeStr.webId&&accessTokens&&idTokens) {
             const result = await getPersonalInfo({
                 webId: window.sessionStorage.getItem('webId'),
                 token: window.sessionStorage.getItem('jwtToken'),
                 lang: i18n.language
             })
             setCustomerProfileDataFromTokens(accessTokens, idTokens, result)
        }
        return jwtDecodeStr;
    }
    //   const next = async (step) =>{
    //     try {
            
    //         if(step != null) {
    //             window.sessionStorage.setItem("ArkleStage", step?.getStage());
    //         } else {
    //             window.sessionStorage.removeItem("ArkleStage");
    //         }

    //         const rsp = await forgerock.FRAuth.next(step);
    //         if(window.showException == true) {
    //             window.showException = false;
    //             throw new new Error("test exception");
    //         } 
    //         if(rsp===undefined){
    //             //cant get rsp
    //             throw new new Error("NetworkError");
    //         }else {
    //             return rsp;
    //         }
    //     } catch (error) {
    //         if (error.message.includes('NetworkError')||error.response) {
    //             console.error('Network error: Please check your internet connection.');
    //             setCIAMLoginIncorrectMsg('100103')
    //         }
    //         else if (error instanceof TypeError && error.message === 'Failed to fetch' || error.message ==='Load failed') {
    //             // Handle network connection lost error here
    //             console.error('Network connection lost. Please check your network settings.');
    //             setCIAMLoginIncorrectMsg('100103')
    //         } else if (error?.message?.includes('Timeout')) {
    //             setCIAMLoginIncorrectMsg('TIMEOUT');
    //         }
    //         else{
    //             console.log('Error in next', error);
    //             setCIAMLoginIncorrectMsg('ERROR')
    //         }

    //     }
    // }
    
    const FR_Logout = async () => {

        // Check for tokens first; end session and revoke and delete if present
        try {
            const tokenStorage = await forgerock?.TokenStorage.get();
            forgerock.SessionManager.logout(); //for clearing Arkle RisingSun cookie

            if (tokenStorage) {
                try {
                    // Revoke tokens on server
                    await forgerock?.OAuth2Client.endSession();
                    await forgerock?.OAuth2Client.revokeToken();
                } catch (error) {
                // Log and continue
                    console.warn('revokeToken and endSession were not successful');
                    console.log(error.message)
                }
                // Locally remove tokens
                await forgerock?.TokenStorage.remove();
            }
            clearSession();

            //clear refresh token interval
            // if(refreshTokenIntervalId) {
            //     clearInterval(refreshTokenIntervalId);
            //     setRefreshTokenIntervalId(null);
            // }
        } catch (error) {
            console.error('Error during logout:', error);
            await forgerock.FRUser.logout(); //try use old method to logout in case of error
            clearSession();
        }

    };

    const getPreNamepass = async (step) => {

        const choiceCallback = step.getCallbackOfType('ChoiceCallback');
        //0 sso, customer always need to enter password so always set choice index to 1
        //if(sessionStorage.getItem('sso_web_id') && sessionStorage.getItem('sso_web_id').length > 0) {
        //    choiceCallback.setChoiceIndex(0);
        //} else {
            choiceCallback.setChoiceIndex(1);
        //}
        
        const rsp = await next(step);

        return rsp;
    }
      // step 1 init
      const FR_initStep = async() => {
        try {
            let step = await next(null);
            const stage = step?.getStage();
            switch(stage) {
                case "pre-namepass":
                    step = await getPreNamepass(step);
                    break;
                case "otp":
                    break;
                case "trust-browser-confirm":
                    break;
            }
            
            setCurrentStep(step);

            return step;
        } catch (error) {
            console.log('Error in init', error);
        }
    }

    const setCIAMLoginIncorrectMsg = (error) => {
        setLoginIncorrectMsg('')
        if(error?.length > 0){
            setTimeout(() => {
                setLoginIncorrectMsg(`LB_BS_LOGIN_ERROR_CIAM_${error}`)
            }, 50);
        }
    }

    const FR_loginWithUsernamePwd = async (username, pwd) => {
        // for testing convenience only
        await FR_Logout();
        let step = await FR_initStep();

        //let step = currentStep;
        let nextStep = step; //currentStep;

        try{
            if(step?.payload?.status == "200" && step?.payload.stage == "namepass"){
                const nameCallback = step.getCallbackOfType('NameCallback');
                const pwdCallback = step.getCallbackOfType('PasswordCallback');
                nameCallback.setName(username);
                pwdCallback.setPassword(pwd);
                nextStep = await next(step); //await forgerock.FRAuth.next(step);
            }

            // if(nextStep?.payload?.status == "200" && nextStep?.payload.stage == "otp"){
                
            //     const otpCallback = JSON.parse(nextStep.getCallbackOfType('TextOutputCallback').getMessage())              
            //     // setMobile({
            //     //     "mobileNo": otpCallback.mobile,
            //     //     "timeout": otpCallback.timeout
            //     // })
            //     closeLoginIncorrectMsg();
            //     setIsShowOTPAuth(true);
            //     WATrackerTrackClickEvent('eWin_CIAM_S1a-OTP_whitelistWithMobile');
            //     window.sessionStorage.setItem("LoginWA", sessionStorage.getItem("LoginWA") + "WithMobile");
            //     step = nextStep;
            //     //ask for geo location
            //     const options = {
            //         timeout: 1000
            //     };
            //     navigator.geolocation.getCurrentPosition(success, error, options);
                

            // }else if(nextStep?.payload?.status == "200" && nextStep?.payload.stage == "trust-browser-confirm") {
            //     setIsShowTrustBrowser(true);
            //     setIsShowOTPAuth(false);
            //     setCIAMLoginIncorrectMsg('')
            //     //step = nextStep;
            // } else 
            if(nextStep?.type == "LoginSuccess"){
                // setIsShowTrustBrowser(false);
                setCIAMLoginIncorrectMsg('')
                // setIsShowOTPAuth(false); // hide otp modal if login success
                step = nextStep;
                if (getLocationParamer('goto')) {
                    return { message: "LoginSuccess", accountNo: username }
                }
                const result = await FR_LoginSuccess(step);
                // await FR_loginWCIP(username, pwd);
                window.sessionStorage.setItem('userId', result.webId)
                window.sessionStorage.setItem('betAcct', result.betAcct)
                return { message: "LoginSuccess", accountNo: result.webId,betAcct: result.betAcct }
            } else if(nextStep?.payload?.status != "200" && nextStep?.type == "LoginFailure"){
                // setIsShowTrustBrowser(false);
                setCIAMLoginIncorrectMsg('100103');
                await FR_Logout().then(FR_initStep());
            } else {
                if(!nextStep?.getCallbacksOfType('TextOutputCallback')?.length) {
                    return;
                }
                
                const rawMessage = nextStep?.getCallbackOfType('TextOutputCallback')?.getMessage();
                let message = null;
                try {
                    message = JSON.parse(nextStep?.getCallbackOfType('TextOutputCallback')?.getMessage());
                } catch(e) {
                    console.log(e)
                }
                const result = message? message.messageId?.replace('ERR', '') : rawMessage;

                await FR_Logout();
                await FR_initStep();
                switch(result){
                    case '100011': //No mobile number available
                        setIsMissingMobile(true)
                        break;                       
                    case '100008': //Not associated with a betting account
                        setCIAMLoginIncorrectMsg(result);
                        break;
                    case '100103': //blacklisted account
                        setCIAMLoginIncorrectMsg('100103');
                     
                        break;
                    case '100014': //locked account
                        setCIAMLoginIncorrectMsg('100014');
                    
                        break;
                    case '100015': //not speedbet customer
                        setCIAMLoginIncorrectMsg('100015');
                     
                        break;
                    case '100003': //invalid sso
                        return 'logout';                        
                    default:
                        setCIAMLoginIncorrectMsg(result);
                        // setPwd?.('')
                        break;

                }
            }

            setCurrentStep(step);
                
        }catch(err){
            if (err.message === 'Timeout') {
                setCIAMLoginIncorrectMsg('TIMEOUT');
            } else {
                setCIAMLoginIncorrectMsg('100103')
                console.error(err)
            }
        }
    };

    //test
    const FR_loginWCIP = async (username, pwd) => {
        try {

            const urlencoded = new URLSearchParams();
            urlencoded.append("username", username);
            urlencoded.append("password", pwd);

            const rawResponse = await fetch(window.globalConfig.VITE_WCIP_API_URL + "/api/login?UIC=zh-hk&EP=BS", {
                method: 'POST',
                headers: {
                    'Accept': '*/*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: urlencoded
            });

            const respJson = await rawResponse.json()
            const msg = await JSON.parse(respJson.Message)
            Cookies.set(msg.Name, msg.Value, { expires: 7, domain: window.globalConfig.VITE_COOKIE_DOMAIN })
            return respJson;
        } catch (error) {
            console.log('Error in FR_loginWCIP', error);
        }
    }

    const genCustProIn = async () => {
        const idToken = Cookies.get('id_token');
        const accessToken = Cookies.get('access_token');
        if(!accessToken&&!idToken)
            return
        const jwtDecodeStr = jwtDecode(accessToken)
        if(jwtDecodeStr.webId&&idToken&&accessToken){
            const result = await getPersonalInfo({
                 webId: jwtDecodeStr.webId,
                 token: accessToken,
                 lang: i18n.language
             })
            setCustomerProfileDataFromTokens(accessToken, idToken, result)
        }

    }

    const setCustomerProfileDataFromTokens = (accessToken, idToken, result) => {
        const iterateFunc = (arr, name) => {
            if(arr && Array.isArray(arr)){
                let returnStr = ""
                arr.forEach((element, id) => {
                    if(name == "o2oSegments"){
                        if(element.value){
                            if(element.value.length==1){
                                returnStr += " "+element.validateFunc
                            }else if(element.value.length==2){
                                returnStr += element.validateFunc
                            }else{
                                returnStr+="**"
                            }
                        }else{
                            returnStr+="  "
                        }
                    }else{
                        if(id==0)
                            returnStr += element
                        else
                            returnStr += "#" + element
                    }
                })
                return returnStr
            }
            return ""
        }
        const accessTokenObj = jwtDecode(accessToken);
        const idTokenObj = jwtDecode(idToken);

        const webData = result?.Message?.WEB?.result
        // const betData = result?.Message?.BET?.result
        // const subData = result?.Message?.subscription
        const customerPreference = result?.Message?.customerPreference?.ResultCustomerPreference
        
        console.debug(accessTokenObj);
        console.debug(idTokenObj);

        let marketingSegments = iterateFunc(idTokenObj.o2oSegments, "o2oSegments");

        var custProInObj = {
            displayName: customerPreference?.displayName,
            salutation: customerPreference?.eAlertLanguage=='C'&&webData?.name?.salutationZh? webData?.name?.salutationZh:webData?.name?.salutationEn,
            lastNameEn: webData?.name?.lastNameEn,
            lastNameZh: webData?.name?.lastNameZh,
            slogan: '',
            sMarketingSegments: marketingSegments,
            webID: accessTokenObj.webId,
            hWebID: accessTokenObj.externalGUID.toLowerCase(),
            priority_card: idTokenObj.isPriorityCardHolder ? "Y" : "N",
            PCardTier: idTokenObj.priorityCardTierCode,
            cbp_seg: idTokenObj.cbpSegment,
            racing_part: idTokenObj.isRacingParticipant ? "Y" : "N",
            football_part: idTokenObj.isFootballParticipant ? "Y" : "N",
            m6_part: idTokenObj.isM6Participant ? "Y" : "N",

            member_type: accessTokenObj.hkjcCardCategoryCode,
            age_group: idTokenObj.agw<10?'0'+idTokenObj.agw:idTokenObj.agw,
            gender: idTokenObj.gcw,
            betting_ac_ind: idTokenObj.bettingAccountNumber? "Y": "N",
            myLoginLanugage: customerPreference?.eAlertLanguage ? (customerPreference?.eAlertLanguage=="C"? "1" : "2" ) : "0",
            speedbet_cust: idTokenObj.hasSpeedbet ? "Y" : "N",
            football_live_ind: idTokenObj.hasWebTv ? "Y" : "N",
            have_webcast_access: idTokenObj.hasWebcast ? "Y" : "N",
            favHorse: iterateFunc(customerPreference?.favHorsesRaw, "favHorse"),
            favTrainers: iterateFunc(customerPreference?.favTrainersRaw, "favTrainers"),
            favTeams: iterateFunc(customerPreference?.favFbTeamsRaw, "favTeams"),
            favJockeys: iterateFunc(customerPreference?.favJockeysRaw, "favJockeys"),
        }

        // sessionStorage.setItem("displayName", customerPreference?.displayName);
        // sessionStorage.setItem("salutation", customerPreference?.eAlertLanguage=='C'&&webData?.name?.salutationZh? webData?.name?.salutationZh:webData?.name?.salutationEn);
        // sessionStorage.setItem("lastNameEn", webData?.name?.lastNameEn);
        // sessionStorage.setItem("lastNameZh", webData?.name?.lastNameZh);
        // sessionStorage.setItem("slogan", '');
        
        // sessionStorage.setItem("sMarketingSegments", marketingSegments);

        // sessionStorage.setItem("webID", accessTokenObj.webId);
        // sessionStorage.setItem("hWebID", accessTokenObj.externalGUID.toLowerCase());

        // sessionStorage.setItem("priority_card", idTokenObj.isPriorityCardHolder ? "Y" : "N");
        // sessionStorage.setItem("PCardTier", idTokenObj.priorityCardTierCode);
        // sessionStorage.setItem("cbp_seg", idTokenObj.cbpSegment);
        // sessionStorage.setItem("racing_part", customerPreference?.isIntInRc ? "Y" : "N");
        // sessionStorage.setItem("football_part", customerPreference?.isIntInFb ? "Y" : "N");
        // sessionStorage.setItem("m6_part", customerPreference?.isIntInM6 ? "Y" : "N");

        // sessionStorage.setItem("member_type", accessTokenObj.hkjcCardCategoryCode);

        // sessionStorage.setItem("age_group", idTokenObj.agw);
        // sessionStorage.setItem("gender", idTokenObj.gcw);
        // // betting_ac_ind missing in CIAM, but assume always Y from eWin
        // sessionStorage.setItem("betting_ac_ind", idTokenObj.bettingAccountNumber? "Y": "N");
        // sessionStorage.setItem("myLoginLanugage", customerPreference?.eAlertLanguage ? (customerPreference?.eAlertLanguage=="C"? "1" : "2" ) : "0");
        // sessionStorage.setItem("speedbet_cust", idTokenObj.hasSpeedbet ? "Y" : "N");
        // sessionStorage.setItem("football_live_ind", idTokenObj.hasWebTv ? "Y" : "N");
        // sessionStorage.setItem("have_webcast_access", idTokenObj.hasWebcast ? "Y" : "N");  
        
        // let favHorse = iterateFunc(customerPreference?.favHorsesRaw, "favHorse");
        // let favTrainers = iterateFunc(customerPreference?.favTrainersRaw, "favTrainers");
        // let favTeams = iterateFunc(customerPreference?.favFbTeamsRaw, "favTeams");
        // let favJockeys = iterateFunc(customerPreference?.favJockeysRaw, "favJockeys");

        // sessionStorage.setItem("favHorse", favHorse);
        // sessionStorage.setItem("favTrainers", favTrainers);
        // sessionStorage.setItem("favTeams", favTeams);
        // sessionStorage.setItem("favJockeys", favJockeys);

        setCustomerSegment(custProInObj);
    }

    const setCustomerSegment = (custProInObj) => {
        const validateFunc = (item, defaultVal, isString=false) => {
            if(isString)
                return item&&item!='undefined'&&item!='null'?item:defaultVal;
            return /^[YN\d]+$/.test(item) ? item : defaultVal;
        };

        const displayName = validateFunc(custProInObj.displayName, '', true);
        const salutation = validateFunc(custProInObj.salutation, '', true);
        const lastNameEn = validateFunc(custProInObj.lastNameEn, '', true);
        const lastNameZh = validateFunc(custProInObj.lastNameZh, '', true);
        const slogan = validateFunc(custProInObj.slogan, '', true);
        const sMarketingSegments = validateFunc(custProInObj.sMarketingSegments, '', true);

        const priority = validateFunc(custProInObj.priority_card, '0');
        let cbp = validateFunc(custProInObj.cbp_seg, '00000');
        if (cbp.length < 5) {
            cbp = new Array(6 - cbp.length).join('0') + cbp;
        }
        const racing = validateFunc(custProInObj.racing_part, 'N');
        const football = validateFunc(custProInObj.football_part, 'N');
        const marksix = validateFunc(custProInObj.m6_part, 'N');
        const member = validateFunc(custProInObj.member_type, '0');
        const ageGroup = validateFunc(custProInObj.age_group, '00');
        const gender = validateFunc(custProInObj.gender, '0');
        const bettingAC = validateFunc(custProInObj.betting_ac_ind, 'N');
        const speedbet = validateFunc(custProInObj.speedbet_cust, '0');
        const footballLive = validateFunc(custProInObj.football_live_ind, 'N');
        const myLoginLanugage = validateFunc(custProInObj.myLoginLanugage, '0');
        const customerSegment =
            priority + cbp + racing + football + marksix + member + ageGroup + gender + bettingAC + myLoginLanugage + speedbet + footballLive;

        const favHorse = validateFunc(custProInObj.favHorse, '', true);
        const favTrainers = validateFunc(custProInObj.favTrainers, '', true);
        const favTeams = validateFunc(custProInObj.favTeams, '', true);
        const favJockeys = validateFunc(custProInObj.favJockeys, '', true);

        const hWebID = validateFunc(custProInObj.hWebID, '', true);
        sessionStorage.setItem('customerSegment', customerSegment);
        sessionStorage.setItem('customerHash', hWebID);
        sessionStorage.setItem('webTV', footballLive == 'Y');

        // const expires = new Date(new Date().getTime() + 60 * 60 * 1000).toUTCString();
        // const cookieValue = `custProInBet=%3A%3A%3A%3A%3A%3A${customerSegment}%3A;expires=${expires};domain=${window.domainName};path=/`;
        const cookieValue = `${displayName}:${salutation}:${lastNameEn}:${lastNameZh}:${slogan}:${sMarketingSegments}:${customerSegment}:${favTeams}:${favHorse}:${favTrainers}:${favJockeys}:${hWebID}`
        sessionStorage.setItem('custProIn', cookieValue);

        Cookies.set('custProIn', cookieValue, { expires: 7, domain: window.globalConfig.VITE_COOKIE_DOMAIN })
    };
    return { 
        FR_loginWithUsernamePwd, 
        loginIncorrectMsg, 
        setCIAMLoginIncorrectMsg,
        isMissingMobile,
        jwtToken,
        FR_loginWCIP,
        FR_Logout,
        genCustProIn
     }
}